















































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { vxm } from "@/store";
import Task from "@/domain/task";
import imagePlaceholder from "@/components/img-placeholder.vue";
import { mediumImageStyle as getMediumImageStyle } from "@/domain/event-medium";

@Component({
  components: {
    "img-placeholder": imagePlaceholder
  }
})
export default class ResultsAnswerCard extends Vue {
  @Prop() task!: Task;
  @Prop() taskIndex!: number;

  mediumImageStyle = getMediumImageStyle;
  tab = 0;
  expandable = false;
  expanded = false;

  get answers() {
    return vxm.results.answers.filter(answer => answer.taskId === this.task.id);
  }

  get media() {
    return vxm.results.allMedia.filter(medium => medium.taskId === this.task.id);
  }

  @Watch("task", { immediate: true })
  taskChanged() {
    setTimeout(() => {
      this.expandable = this.$el.scrollHeight >= 300;
    });
  }
}
